export const numeroParser = (value) => {
	if (value) {
		return value.substring(0, 20);
	}
};
